import {
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  JsonIgnoreUnknownKeys124eml6s7t6h6 as JsonIgnoreUnknownKeys,
  JsonNames3i9ju5gyx18ko as JsonNames,
} from '../JsonAnnotations.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
  ENUM_getInstance3ph4fa6o285vr as ENUM_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_schemaCache3drvxe6e7799s as get_schemaCache } from '../JsonSchemaCache.mjs';
import { toSet1glep2u1u9tcb as toSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/JsonInternalDependencies.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  JsonEncodingException1thxguokvyir3 as JsonEncodingException,
  JsonDecodingException278mackfi1uuk as JsonDecodingException,
} from './JsonExceptions.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { singleOrNullrknfaxokm1sl as singleOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Key2w5p0aa9mfn6d as Key } from './SchemaCache.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function ignoreUnknownKeys(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp;
  if (json.f2m_1.r2n_1) {
    tmp = true;
  } else {
    var tmp0 = _this__u8e3s4.l1p();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.n1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof JsonIgnoreUnknownKeys()) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$0);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.n1p(name);
  if (!(index === -3))
    return index;
  if (!json.f2m_1.b2o_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException().h1o(_this__u8e3s4.p1n() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.m1p(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.i1p(), CLASS_getInstance()) ? json.f2m_1.c2o_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.x2r(descriptor, tmp_0, () => buildDeserializationNamesMap(descriptor, _this__u8e3s4));
}
function getJsonEncodedNames(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? jsonCachedSerialNames(_this__u8e3s4) : toSet(serializationNamesIndices(_this__u8e3s4, json, strategy));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.f2m_1.d2o_1 && equals(descriptor.i1p(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).u4(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.x2r(_this__u8e3s4, tmp_0, () => {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var trackingSet = LinkedHashSet().s2();
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.k1p();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = _this__u8e3s4.m1p(tmp_2);
      var name = strategy.y2r(_this__u8e3s4, tmp_2, baseName);
      if (!trackingSet.i2(name))
        throw JsonEncodingException().v2r("The transformed name '" + name + "' for property " + baseName + ' already exists ' + ('in ' + toString(_this__u8e3s4)));
      tmp_1[tmp_2] = name;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  });
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap().bc();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.k1p();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = _this__u8e3s4.o1p(i);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList().p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof JsonNames()) {
          destination.i2(element);
        }
      }
      var tmp0_safe_receiver = singleOrNull(destination);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z2r_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.m1p(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.y2r(_this__u8e3s4, i, _this__u8e3s4.m1p(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (builder.n1()) {
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.i1p(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap()) ? _this__u8e3s4 : THROW_CCE()).s4(name)) {
    throw JsonDecodingException().p2p("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.m1p(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.m1p(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.x4(name, index);
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new (Key())();
    JsonSerializationNamesKey = new (Key())();
  }
}
//region block: exports
export {
  get_JsonDeserializationNamesKey as get_JsonDeserializationNamesKey2d6gbfp1rff81,
  deserializationNamesMap as deserializationNamesMap29c3n2byxqy5b,
  getJsonElementName as getJsonElementName36ciq3w3g8x0l,
  getJsonEncodedNames as getJsonEncodedNames32epqb27gispq,
  getJsonNameIndexOrThrow as getJsonNameIndexOrThrow1a6a29i1xie0m,
  getJsonNameIndex as getJsonNameIndex1fee1p51fy8fj,
  ignoreUnknownKeys as ignoreUnknownKeys1ot1okvsp9ttf,
  namingStrategy as namingStrategy2xiv9qzked2jy,
};
//endregion

//# sourceMappingURL=JsonNamesMap.mjs.map
